<template>
  <div class="PageTitle">
	<Heading level="h1" color="highlight">{{ this.$t('nav.' + $route.meta.title) | capitalize }}</Heading>
	<ul v-if="$route.meta.breadcrumbs.length > 1" class="fColorGrey">
		<li v-for="(val,index) in $route.meta.breadcrumbs" :key="index">
			<Link :path="val.path" :label="$t('nav.' + val.name)" v-if="index != $route.meta.breadcrumbs.length - 1"></Link>
			<span v-else>{{ $t('nav.' + val.name) }}</span>
		</li>
	</ul>
  </div>
</template>

<script>
  import Heading from '../atoms/Heading.vue'
  import Link from '../atoms/Link.vue'
  
  export default {
    name: "PageTitle",
    components: {
      Heading,
      Link
    },
    computed: {},
    methods: {},
    created() {
      console.log(this.$route.matched.length)
      console.log(this.$route)
    },
    filters: {
      capitalize: function (value) {
        if (!value) return ''
        value = value.toString()
        return value.charAt(0).toUpperCase() + value.slice(1)
      }
    }
  }
</script>

<style scoped="">
.PageTitle {
	margin: 0;
	padding: 20px;
	background-color: #fff;
	border-bottom: 1px solid #dadee1;
}
ul {
	list-style: none;
	margin: 0;
	padding: 0;
}
li {
	display: inline;
	font-size: 0.9em;
}
li+li:before {
  padding: 4px;
  content: "\003e";
}
</style>
